export default __webpack_public_path__ + "static/media/check_circle.728a92e8.svg";